<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left;"></div>
  </div>
</template>
<script>
import E from "wangeditor";
import ImgUploader from "@/models/img-upload.js";
const imgUploader = new ImgUploader();
// const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = E
export default {
  name: "editorElem",
  data() {
    return {
      editor: null,
      editorContent: ""
    };
  },
  props: {
    catchData: {
      type: Function
    },
    content: {
      type: String
    },
    isUpdate: {
      type: Boolean,
      default: true
    }
  },
  // 接收父组件的方法
  watch: {
    content(newVal, odlVal) {
      this.editor.txt.html(this.content);
      this.editor.config.change && this.editor.config.change();
    },
    isUpdate(newVal) {
      this.editor.$textElem.attr("contenteditable", newVal);
    }
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem);
    this.editor.config.zIndex = 20;
    this.editor.config.debug =
      location.href.indexOf("wangeditor_debug_mode=1") > 0;

    this.editor.config.uploadFileName = "files";
    this.editor.config.onblur = html => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };

    this.editor.config.uploadImgShowBase64 = true; // base 64 存储图片
    this.editor.config.pasteFilterStyle = false;
    this.editor.config.uploadImgMaxLength = 1; // 限制一次最多上传  张图片
    this.editor.config.uploadImgTimeout = 8000;
    this.editor.config.customUploadImg = (files, insert) => {
      imgUploader.postImgUpload(files[0]).then(res => {
        let url = res.imgUrl.replace(
          /ydb-kz.oss-cn-.+.aliyuncs.com/,
          "image.8844it.com"
        );
        insert(url);
      });
    };
    this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M

    
    // // 第一，菜单 class ，Button 菜单继承 BtnMenu class
    // class AlertMenu extends BtnMenu {
    //   constructor(editor) {
    //     // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
    //         const $elem = E.$(
    //           `<div class=\"w-e-menu\" data-title=\"标记">\n                <i class=\"el-icon-moon\"></i>\n            </div>`
    //         )
    //         super($elem, editor)
    //     }
    //     // 菜单点击事件
    //     clickHandler() {
    //         // 做任何你想做的事情
    //         // 可参考【常用 API】文档，来操作编辑器
    //       var _a;

    //       var editor = this.editor;
    //       var isEmptySelection = editor.selection.isSelectionEmpty();
    //       let color = editor.selection.getSelectionContainerElem().elems[0].color
    //       var $selectionElem = (_a = editor.selection.getSelectionContainerElem()) === null || _a === void 0 ? void 0 : _a.elems[0];
    //       if ($selectionElem == null) return; // 获取选区范围的文字
    //       var $selectionText = editor.selection.getSelectionText(); // 如果设置的是 a 标签就特殊处理一下，避免回车换行设置颜色无效的情况
    //       // 只处理选中a标签内全部文字的情况，因为选中部分文字不存在换行颜色失效的情况
    //       if ($selectionElem.nodeName === 'A' && $selectionElem.textContent === $selectionText) {
    //         // 创建一个相当于占位的元素
    //         var _payloadElem = dom_core_1["default"]('<span>&#8203;</span>').getNode(); // 添加到a标签之后

    //         $selectionElem.appendChild(_payloadElem);
    //       }
    //       console.log(color);
    //       editor.cmd.do('insertHTML', `<span style="cursor: pointer;color:${color};" onclick="unscramble('${$selectionText}')">${$selectionText}</span>`);
    //       if (isEmptySelection) {
    //         // 需要将选区范围折叠起来
    //         editor.selection.collapseRange();
    //         editor.selection.restoreSelection();
    //       }
    //     }
    // }
    // const menuKey = 'alertMenuKey' 
    // this.editor.menus.extend(menuKey, AlertMenu)
    // this.editor.config.menus = this.editor.config.menus.concat(menuKey)
    // this.editor.config.menus = [
    //   // 菜单配置
    //   "head", // 标题
    //   "bold", // 粗体
    //   "fontSize", // 字号
    //   "fontName", // 字体
    //   "italic", // 斜体
    //   "underline", // 下划线
    //   "strikeThrough", // 删除线
    //   "foreColor", // 文字颜色
    //   "backColor", // 背景颜色
    //   "link", // 插入链接
    //   "list", // 列表
    //   "justify", // 对齐方式
    //   "quote", // 引用
    //   // 'emoticon', // 表情
    //   "image", // 插入图片
    //   "table", // 表格
    //   "code", // 插入代码
    //   "undo", // 撤销
    //   "redo", // 重复
    //   "sign"
    // ];
    // 下面是最重要的的方法
    this.editor.config.uploadImgHooks = {
      fail: (xhr, editor, result) => {
        // 插入图片失败回调
      },
      success: (xhr, editor, result) => {
        // 图片上传成功回调
      },
      timeout: (xhr, editor) => {
        // 网络超时的回调
      },
      error: (xhr, editor) => {
        // 图片上传错误的回调
      },
      customInsert: (insertImg, result, editor) => {
        // 图片上传成功，插入图片的回调
        var url = result.data;
        insertImg(url);
      }
    };

    this.editor.create(); // 创建富文本实例
    this.editor.$textElem.attr("contenteditable", this.isUpdate);
    if (!this.content) {
      this.editor.txt.html("");
    }
  }
};
</script>
<style lang="scss">
#wangeditor {
  max-width: 100%;
  height: 100%;
  .w-e-toolbar {
    background: $bg-white !important;
  }
  .w-e-text-container {
    height: 480px !important;
    max-width: 100%;
    .w-e-text {
      ol > li {
        list-style: decimal outside none;
      }
      ul > li {
        list-style: disc outside none;
      }
      table {
        width: 100% !important;
      }
    }
  }
}
</style>
